export class ServiceUnavailable extends Error {
  constructor() {
    super()
    this.name = this.constructor.name
  }
}
